
import Cta from '@/components/ui/cta.vue';
import WpImage from '~/components/ui/img.vue';

export default {
  name: 'ContentPanel',

  components: {
    Cta,
    WpImage,
  },

  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      imageObject: null,
    };
  },

  mounted() {
    this.checkIfMobile();
  },

  methods: {
    checkIfMobile() {
      this.imageObject =
        window && window.innerWidth < 720 && this.data.image_mobile
          ? this.data.image_mobile
          : this.data.image;
    },
  },
};
